export enum ReassignmentType {
  technical = "technical",
  client = "client"
}
